/* =============================================================================
   PlateX — Initials Reference · Phase 1 inline fixtures.
   Copy is verbatim from the approved Initials v5 prototype (build pack §6),
   with the pack's mechanical conversions applied:
     · no em/en dashes as punctuation
     · no illustrative market figures on the draft route
   Do not edit copy here without design sign-off.
   ========================================================================== */

export interface Chapter {
  id: string;
  label: string;
  hot?: boolean;
}

/** Sticky chapter navigation (prototype chapnav; anchors per the build pack). */
export const CHAPTERS: Chapter[] = [
  { id: 'profile', label: 'Your initials', hot: true },
  { id: 'budget', label: 'By budget' },
  { id: 'explore', label: 'By format' },
  { id: 'next', label: 'Where next' },
];

export interface RelatedCard {
  title: string;
  description: string;
  /** routerLink target; null renders a non-navigating card (route not built). */
  link: string[] | null;
}

/** Related collections (prototype "Where next") with real route targets. */
export const RELATED_COLLECTIONS: RelatedCard[] = [
  // Build your own returns once its redesigned page ships.
  {
    title: 'Dateless registrations',
    description: 'The oldest and most collected form of your initials.',
    link: ['/plates', 'dateless'],
  },
  {
    title: 'Plate Viewer',
    description: 'See any of these on your own car before you buy.',
    link: ['/plate-viewer'],
  },
];
